import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryListLatestIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items,
}: StoryListLatestIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
